import React, { useEffect } from 'react';
import { Card, Typography, useTheme } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthlyAppointmentsRequest } from './../../store/appActions';

export default function AppointmentChart() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const chartData = useSelector((state) => state.app.monthlyappointments || []);

    // console.log('chartData :',chartData)

  useEffect(() => {
    dispatch(getMonthlyAppointmentsRequest());
  }, [dispatch]);

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        fontWeight={theme.typography.h6.fontWeight}
        fontFamily={theme.typography.fontFamily}
        color={theme.palette.text.primary}
      >
        Appointments Per Month
      </Typography>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="name"
            stroke={theme.palette.text.secondary}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 14 }}
          />
          <YAxis
            stroke={theme.palette.text.secondary}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 14 }}
          />
          <Tooltip
            wrapperStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: 14,
              backgroundColor: theme.palette.background.paper,
              borderColor: theme.palette.divider,
              borderWidth: 1,
              borderStyle: 'solid',
              borderRadius: 4,
              color: theme.palette.text.primary,
            }}
            contentStyle={{ padding: '6px 10px' }}
          />
          <Bar
            dataKey="appointments"
            fill={theme.palette.primary.main}
            radius={[4, 4, 0, 0]}
            barSize={40}
          />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
